import React from "react";
import { useGetBankAccounts, useGetInvoices, useGetInvoiceStates, useGetInvoiceTypes } from "../../hooks/data/data_invoice";
import { CustomCircularProgress } from "../../components/core/CustomCircularProgress";
import { ErrorTryRefetch } from "../../components/core/ErrorTryRefetch";
import { Typography } from "@mui/material";
import { RecipientOfPaymentOverview } from "../../components/recipientOfPayment/RecipientOfPaymentOverview";
import { InvoicesOverview } from "../../components/invoice/InvoicesOverview";


export const InvoiceOverview:React.FC = () => {
    const { invoices, isLoadingInvoices, refetchInvoices, isFetchingInvoices  } = useGetInvoices();
    const { invoiceStates, isLoadingInvoiceStates, refetchInvoiceStates } = useGetInvoiceStates();
    const { invoiceTypes, isLoadingInvoiceTypes, refetchInvoiceTypes } = useGetInvoiceTypes();
    //
    const { bankAccounts, isLoadingBankAccounts, refetchBankAccounts } = useGetBankAccounts();
 
    const refetchAll = () => {
        refetchInvoices();
        refetchInvoiceStates();
        refetchInvoiceTypes();
        refetchBankAccounts();
    }


    if (
        isLoadingInvoices
        || isLoadingInvoiceStates
        || isLoadingInvoiceTypes
        || isLoadingBankAccounts
    ) {
        return <CustomCircularProgress/>
    }

    if (
        !invoices
        || !invoiceStates
        || !invoiceTypes
        || !bankAccounts
    ) {
        return <ErrorTryRefetch
                    refetchFunction={refetchAll}
                />
    }

    return(
        <>
            <Typography
                variant="h5"
                sx={{display: "flex"}}
            >
                Rechnungsverwaltung

            </Typography>

            <RecipientOfPaymentOverview
                bankAccounts={bankAccounts}
                refetchBankAccounts={refetchBankAccounts}
            />

            <InvoicesOverview
                bankAccounts={bankAccounts}
                invoiceStates={invoiceStates}
                invoiceTypes={invoiceTypes}
                invoices={invoices}
                refetechInvoices={refetchInvoices}
                isFetchingInvoices={isFetchingInvoices}
            />
            
        </>
    )
}